import AuthForm from '#Auth/components/Form/AuthForm.vue'
import { AuthFormAction } from '#Auth/components/Form/type'

export const useAuthInteractive = () => {
  const action = ref<AuthFormAction>(AuthFormAction.signIn)

  const { startAdd } = useFormModal({
    formComponent: AuthForm,
    overlayType: 'modal',
    dictionaries: {
      title: ' ',
    },
    formAttrs: {
      action,
      // Getter: useFormModal unwraps via toValue(), which invokes functions
      onGoTo: () => handleChangeAction,
    },
    onSubmit() {
      return true
    },
    modalProps: {
      ui: {
        content: 'max-w-md w-[calc(100vw-2rem)]',
        header: 'border-none min-h-0 py-2 sm:px-4',
        title: 'sr-only',
        body: 'pt-2 sm:pt-2',
      },
    },
  })

  function handleChangeAction(newAction: AuthFormAction) {
    action.value = newAction
  }

  function openAuth(newAction: AuthFormAction = AuthFormAction.signIn) {
    action.value = newAction
    startAdd()
  }

  return {
    openAuth,
  }
}
